import { SCREEN_NAME } from 'constants/index';
import { sendUIEvent, sendScreenEvent } from 'services/analytics';

const ANALYTICS_SOURCE = SCREEN_NAME.ERROR;

// https://data-portal.internal.atlassian.com/analytics/registry/84835
const trackErrorScreenView = (errorType: string, errorDescription: string) => {
  sendScreenEvent({
    screenName: ANALYTICS_SOURCE,
    attributes: {
      errorType,
      errorDescription: errorDescription.substring(0, 100),
    },
    isPersonalView: false,
  });
};

// https://data-portal.internal.atlassian.com/analytics/registry/84832
const trackUnifiedProfileErrorRecoveryClick = (
  errorType: string,
  recoveryAction: string,
  destination: string,
) => {
  sendUIEvent({
    source: ANALYTICS_SOURCE,
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'unifiedProfileErrorRecovery',
    attributes: {
      errorType,
      recoveryAction,
      destination,
    },
    isPersonalView: false,
  });
};

export { trackErrorScreenView, trackUnifiedProfileErrorRecoveryClick };
